import styled, { css } from "styled-components";
import { TextButton } from "../../../../components/textButton";

export const TextButtonModal = styled(TextButton)(({ theme }) => css`
  color: ${theme.buttons.link.color};
  text-decoration: underline;

  &:hover {
    color: ${theme.buttons.link.hoverColor};
  }
`);